// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();



//mobile menu

const menu = document.querySelector('.burger-icon');
const close = document.querySelector('.button-close');
console.log(menu);
//on click burger show menu and change burger to close button <app-icon-close>
menu.addEventListener('click', function () {
	console.log('click')
	document.querySelector('#burger').classList.toggle('show');
});

close.addEventListener('click', function () {
	document.querySelector('#burger').classList.remove('show');
});

